import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Paper from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
/**
 * The contact section provides a simple form for collecting leads along with
 * alternative methods of communication.  Form state is managed locally and
 * resets after submission; in a real deployment you would integrate
 * submission with a backend service such as an email handler or CRM.
 */
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
    const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you could send data to a backend or service
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <Box id="contacto" sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container>
        <Typography
         variant="h3"
          component="h2"
          textAlign="center"
            sx={{
            mb: 4,
            fontWeight: 600,
              display: 'block',
            px: 2,
             pt: 0.5,
            pb: 1.5,
            bgcolor: pearlGlass,
            color: 'text.primary',
            backdropFilter: 'blur(6px)',
            borderRadius: 1,
          }}
        >
          Contáctanos
        </Typography>
        <Typography variant="body1" textAlign="center" sx={{ mb: 4 }}>
          ¿Tienes alguna consulta o requieres una cotización? Nuestro equipo está listo para atenderte.
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
             <Paper sx={{ p: 3, boxShadow: '0px 6px 20px rgba(0,0,0,0.06)' }}>
              {submitted && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Gracias, su mensaje ha sido enviado. Nos pondremos en contacto pronto.
                </Alert>
              )}
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <TextField
                    label="Nombre completo"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    fullWidth
                    variant="filled"
                  />
                  <TextField
                    label="Correo electrónico"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    fullWidth
                    variant="filled"
                  />
                  <TextField
                    label="Teléfono"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    fullWidth
                    variant="filled"
                  />
                  <TextField
                    label="Mensaje"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    multiline
                    rows={4}
                    fullWidth
                    variant="filled"
                  />
                  <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
                    Enviar Mensaje
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                O contáctanos por WhatsApp
              </Typography>
              <Button
                variant="contained"
                startIcon={<WhatsAppIcon />}
                href="https://wa.me/584122373053"
                         sx={{
                  mb: 3,
                  width: '100%',
                  backgroundColor: '#25D366',
                  '&:hover': { backgroundColor: '#1DA851' },
                  borderRadius: 2,
                }}
              >
                     Contactanos por WhatsApp
              </Button>
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <PhoneIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">+58 412 237 3053</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">contacto@acopiaserwa.com</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOnIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    Av. Principal Troncal del Caribe, Guarero, Guajira, Venezuela
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOnIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">Maracaibo, Estado Zulia, Venezuela</Typography>
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;